import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { toggleMaximizeWidget } from '../../common';
import { IWidget, IMaximizable } from '../../widgets';

class MaximizableController implements angular.IController {
    static controllerId = 'WtMaximizable';

    item: IWidget & IMaximizable;
    state: string;
    itemGuid: string;
    params: any;

    static $inject = ['$rootScope', '$state'];

    constructor(
        private _$rootScope: angular.IRootScopeService,
        private _$state: angular.ui.IStateService
    ) { }

    $onInit() {
        /* nothing */
    }

    openNewWindow() {
        let url: string;
        let params: {};

        if (this.itemGuid) {
            if (this.state === 'trend') {
                params = { beginDate: '', endDate: '', trendGuid: this.itemGuid, maximized: this.item.guid };
            }
            if (this.state === 'dashboard') {
                params = { dashboardName: this.itemGuid, maximized: this.item.guid };
            }
            url = this.getUrl(this.state, params);
        } else {
            if (this.state === 'group.validation' && this.params) {
                params = this.params;
            } else {
                params = { maximized: this.item.guid };
            }
            url = this._$state.href(this.state, params, { absolute: true });
        }
        if (url) {
            (<any>window).trendSeries = JSON.stringify(this.item.series);
            const win = window.open(url, '_blank', `height=${screen.height},width=${screen.width}`);
            (<any>win).trendSeries = JSON.stringify(this.item.series);
        }
    }

    watchKeyPress($event) {
        if ($event.keyCode === 27) {
            if (this.item.isMaximized && !this.item.isDisabledMaximized) {
                this.item.isMaximized = false;
                $event.preventDefault();
            }
        }
    }

    toggleMaximize(): void {
        this.item.isMaximized = !this.item.isMaximized;
        this._$rootScope.$broadcast(toggleMaximizeWidget, { isMaximized: this.item.isMaximized });
    }

    isOpenableInNewWindow(): boolean {
        if (this.state === 'trend') {
            return (this.itemGuid) ? true : false;
        } else {
            return true;
        }
    }

    private getUrl(state: string, params: {}): string {
        return this._$state.href(state, params, { absolute: true });
    }
}

export const wtMaximizable: ComponentDefinition = {
    componentId: 'wtMaximizable',
    controller: MaximizableController,
    controllerAs: 'vm',
    template: require('./maximizable.component.html'),
    bindings: {
        item: '=',
        state: '@',
        itemGuid: '<?',
        params: '<?'
    }
};